import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { handlePostRequest } from '../../utils/api-handler.util'
import { showToaster } from '../../utils/show-toaster.util'
import BackIcon from '../../components/icons/BackIcon'
import InputField from '../../components/common/InputField'
import { useHistory } from '../../contexts/HistoryContext'

export default function ForgotPasswordReset() {
  const { state } = useLocation()
  const phoneNumber = state?.phoneNumber
  const [newPassword, setNewPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const { goBackOrHome } = useHistory()

  const resetPasswordMutation = useMutation({
    mutationFn: (data) => handlePostRequest('/reset-password', data),
    onSuccess: () => {
      showToaster('success', 'Password reset successfully!')
      navigate('/login')
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.message || 'Failed to reset password'
      setError(errorMessage)
    },
  })

  const handleReset = (e) => {
    e.preventDefault()
    setError('')

    if (newPassword !== passwordConfirmation) {
      setError('Passwords do not match')
      return
    }

    resetPasswordMutation.mutate({
      phoneNumber,
      newPassword,
      passwordConfirmation,
    })
  }

  return (
    <div className="w-full max-w-md min-h-screen mx-auto bg-background shadow-lg rounded-xl overflow-hidden">
      <div className="flex items-center p-4">
        <button
          className="flex items-center justify-center bg-background border border-gray-200 rounded-full w-10 h-10 shadow-sm hover:bg-neutral-200-50 transition-colors duration-200"
          onClick={() => goBackOrHome()}
          aria-label="Back"
        >
          <BackIcon />
        </button>
      </div>

      <div className="flex justify-center py-8">
        <img src="/eastsoko-logo.png" alt="Sokooni Logo" className="w-36 object-contain" />
      </div>

      <div className="px-6 pb-8">
        <h1 className="text-2xl font-bold text-foreground text-center font-inter mb-2">
          Reset Password
        </h1>
        <p className="text-sm font-medium text-medium-opacity text-center font-inter mb-8">
          Create your new password
        </p>

        <form onSubmit={handleReset} className="space-y-6">
          <InputField
            type="password"
            id="newPassword"
            label="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter new password"
            required
          />

          <InputField
            type="password"
            id="passwordConfirmation"
            label="Confirm Password"
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            placeholder="Confirm new password"
            required
          />

          {error && <div className="text-error-900 text-sm font-medium text-center">{error}</div>}

          <button
            type="submit"
            className="w-full py-3 bg-gradient-to-r from-secondary-700 to-secondary-500 text-white text-lg font-medium font-inter rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 disabled:opacity-70"
            disabled={resetPasswordMutation.isPending}
          >
            {resetPasswordMutation.isPending ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  )
}
